module.exports = __webpack_public_path__ + "static/media/github-logo-white.648103ae.svg";